import {
  DeleteFileCommand,
  DeleteFileCommandOutput,
  DeleteFileCommandInput,
} from "@amzn/ttechclaimintakeservice-client";

import { getAuthenticatedClient } from "../setup/getAuthenticatedClient";
import { MetricsPublisher } from "../../metrics/metrics";

export async function deleteFileService(input: DeleteFileCommandInput) {
  const { client } = await getAuthenticatedClient();
  if (!client) {
    return Promise.reject(new Error("Unauthorized"));
  }
  const command = new DeleteFileCommand(input);
  const metricsPublisher = new MetricsPublisher("api.deleteFile");

  return await client
    .send(command)
    .then((response: DeleteFileCommandOutput) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderSuccessMetrics();
      return response;
    })
    .catch((error) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderFatalMetrics();
      throw error;
    });
}
